import icon from "../../assets/lock.svg";
import type { Property } from "../../types";

export const outputRelays: Property = {
  id: "outputRelays",
  title: "outputRelays.title",
  icon,
};
